import React, { useEffect, useState } from "react";
import "./Collections.css";
import axios from "axios";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ProductCard from "../../components/ProductCard/ProductCard";
import { useNavigate } from "react-router-dom";

function Collections() {
  const navigate = useNavigate();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    scrollToTop();
  }, [navigate]);

  const [collectionItems, setCollectionItems] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const [selectedCollections, setSelectedCollections] = useState([]);
  const [priceRange, setPriceRange] = useState([0, 50000]);
  const [sortOption, setSortOption] = useState("low-to-high");

  const baseURL = "https://karstar.in/";

  useEffect(() => {
    fetchProduct();
  }, []);

  const fetchProduct = async () => {
    try {
      const response = await axios.get(
        `${baseURL}api/client_api/collections/index.php`
      );
      const fetchedItems = response.data;
      setCollectionItems(fetchedItems);
      setIsLoading(false);
    } catch (err) {
      setError(err.message);
      setIsLoading(false);
    }
  };

  const handleCollectionChange = (e) => {
    const value = e.target.value;
    setSelectedCollections((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value]
    );
  };

  const sortItems = (items) => {
    let sorted = [...items];

    switch (sortOption) {
      case "low-to-high":
        sorted.sort(
          (a, b) =>
            Number(a.price[0].discountedPrice) -
            Number(b.price[0].discountedPrice)
        );
        break;

      case "high-to-low":
        sorted.sort(
          (a, b) =>
            Number(b.price[0].discountedPrice) -
            Number(a.price[0].discountedPrice)
        );
        break;

      case "recent":
        sorted.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        break;

      case "oldest":
        sorted.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
        break;

      default:
        break;
    }

    return sorted;
  };

  const filterProducts = () => {
    let results = [];

    // Merge all products from all collections
    Object.keys(collectionItems).forEach((collection) => {
      results.push(...collectionItems[collection]);
    });

    // Remove duplicate products
    results = results.filter(
      (item, index, self) => index === self.findIndex((p) => p.id === item.id)
    );

    // FILTER BY COLLECTION
    if (selectedCollections.length > 0) {
      results = results.filter((item) =>
        item.collection.some((col) => selectedCollections.includes(col))
      );
    }

    // FILTER BY PRICE
    results = results.filter((item) => {
      const price = Number(item.price[0].discountedPrice);
      return price <= priceRange[1];
    });

    // SORTING
    results = sortItems(results);

    return results;
  };

  const filteredItems = filterProducts();

  return (
    <div className="sectionView container mt-3">
      <div className="breadcrumb-container">
        <div className="breadcrumb">
          <a href="/" className="breadcrumb-item text-black">
            Home
          </a>
          <div className="breadcrumb-item text-black">All Products</div>
        </div>
      </div>

      {error && <div>{error}</div>}

      <Row className="mt-4">
        {/* LEFT FILTER SIDEBAR */}
        <Col lg={3} md={4} sm={12} className="mb-4">
          <div style={{ position: "sticky", top: "14vh" }}>
            {/* PRICE FILTER */}
            <div className="filter-box mb-2 p-3 border rounded">
              <h5 className="fw-bold mb-2">Price</h5>

              <input
                type="range"
                min="0"
                max="50000"
                value={priceRange[1]}
                onChange={(e) => setPriceRange([0, Number(e.target.value)])}
                className="form-range"
              />

              <p className="small">Up to: ₹{priceRange[1]}</p>
            </div>

          </div>
        </Col>

        {/* RIGHT PRODUCT GRID */}
        <Col lg={9} md={8} sm={12}>
          <Row className="g-0">
            {isLoading ? (
              <div>Loading...</div>
            ) : filteredItems.length > 0 ? (
              filteredItems.map((item, index) => (
                <Col lg={3} md={4} sm={6} xs={6} key={index}>
                  <ProductCard
                    item={item}
                    baseUrl={baseURL}
                    wishlist={item.price.some((p) => p.in_wishlist)}
                    cart={item.price.some((p) => p.in_cart)}
                    analyticsContext="collections_page"
                  />
                </Col>
              ))
            ) : (
              <div>No products found</div>
            )}
          </Row>
        </Col>
      </Row>
    </div>
  );
}

export default Collections;
